/* ============================================================
   Lifestyle preferences — onboarding popup / bottom sheet
   POST https://livgood-pt.herokuapp.com/api/v2/preferences
        { email, collectionIds: ["gid://shopify/Collection/…"], personas: ["parent", …] }
   ============================================================ */

const LGP_API_BASE = 'https://livgood-pt.herokuapp.com/api/v2/preferences';
const LGP_STORAGE_COLLECTIONS = 'selected_lifestyles'; // also read by lifestyle-products-carousel
const LGP_STORAGE_PERSONAS = 'selected_personas';
const LGP_STORAGE_SNOOZE = 'lgp_prompt_snoozed_until';
const LGP_SNOOZE_DAYS = 7;

/* ── Icons ────────────────────────────────────────────────── */

const LGP_ICON = {
  leaf: '<path d="M4 20C4 11 10 5 20 4c0 10-6 16-15 16Z"/><path d="M4 20c4-4 8-7 12-8.5"/>',
  wheat:
    '<path d="M12 21v-9"/>' +
    '<path d="M12 12c-2.2 0-4-1.8-4-4 2.2 0 4 1.8 4 4Z"/><path d="M12 12c2.2 0 4-1.8 4-4-2.2 0-4 1.8-4 4Z"/>' +
    '<path d="M12 17c-2.2 0-4-1.8-4-4 2.2 0 4 1.8 4 4Z"/><path d="M12 17c2.2 0 4-1.8 4-4-2.2 0-4 1.8-4 4Z"/>' +
    '<path d="M12 7.5c-1.4 0-2.5-1.7-2.5-3.7 1.4 0 2.5 1.7 2.5 3.7Z"/><path d="M12 7.5c1.4 0 2.5-1.7 2.5-3.7-1.4 0-2.5 1.7-2.5 3.7Z"/>',
  milk:
    '<path d="M10 2h4v3l2.3 3.3a4 4 0 0 1 .7 2.2V19a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-8.5a4 4 0 0 1 .7-2.2L10 5V2Z"/>' +
    '<path d="M7 13h10"/>',
  dumbbell: '<path d="M3 9v6M6 7v10M18 7v10M21 9v6M6 12h12"/>',
  avocado:
    '<path d="M12 21c-3.9 0-6.5-3-6.5-6.6 0-3.3 2.2-4.6 3-7.3C9.2 4.6 10.2 3 12 3s2.8 1.6 3.5 4.1c.8 2.7 3 4 3 7.3C18.5 18 15.9 21 12 21Z"/>' +
    '<ellipse cx="12" cy="14.6" rx="2.6" ry="3"/>',
  apple:
    '<path d="M12 8c-1-1-2.4-1.6-3.8-1.4C5.7 6.9 4 9.2 4 12.4 4 16.6 7 21 9.9 21c1 0 1.5-.5 2.1-.5s1.1.5 2.1.5C17 21 20 16.6 20 12.4c0-3.2-1.7-5.5-4.2-5.8C14.4 6.4 13 7 12 8Z"/>' +
    '<path d="M12 8V5.5A2.5 2.5 0 0 1 14.5 3"/>',
  sugar:
    '<rect x="2.5" y="12" width="8.5" height="8" rx="1.5"/><rect x="13" y="12" width="8.5" height="8" rx="1.5"/>' +
    '<rect x="7.75" y="3.6" width="8.5" height="8" rx="1.5"/>',
  sprout:
    '<path d="M12 21v-7"/><path d="M12 14c0-3.3 2.7-6 6-6 0 3.3-2.7 6-6 6Z"/>' +
    '<path d="M12 16.5c-3.1 0-5.5-2.5-5.5-5.5 3.1 0 5.5 2.5 5.5 5.5Z"/>',
  pea:
    '<path d="M5 6c7.7 0 14 5.3 14 13C11.3 19 5 13.7 5 6Z"/>' +
    '<circle cx="9.6" cy="10.6" r="1.25"/><circle cx="12.6" cy="13.4" r="1.25"/><circle cx="15.4" cy="16.2" r="1.25"/>',
  tummy:
    '<path d="M8.5 3v4.6c0 2-1.3 2.7-2.6 3.8A5.6 5.6 0 0 0 9.4 21c4 0 6-2.5 7.3-5.3.6-1.2 1.5-1.7 2.6-1.7"/>' +
    '<path d="M8.5 3H12a6 6 0 0 1 6 6v2.4"/>',
  flask:
    '<path d="M9 3v6.3L4.6 17A2.5 2.5 0 0 0 6.8 21h10.4a2.5 2.5 0 0 0 2.2-4L15 9.3V3"/>' +
    '<path d="M8 3h8"/><path d="M7.3 14h9.4"/>',
  dietitian:
    '<circle cx="12" cy="7" r="3.4"/><path d="M5 21a7 7 0 0 1 14 0"/><path d="M12 14.6v3.2M10.4 16.2h3.2"/>',
  lotus:
    '<circle cx="12" cy="4.8" r="2.3"/><path d="M12 8.2c-1.7 0-2.9 1.3-3.3 2.8L8 14.4"/>' +
    '<path d="M12 8.2c1.7 0 2.9 1.3 3.3 2.8l.7 3.4"/>' +
    '<path d="M4 17.6c1.6-2.5 4.6-4 8-4s6.4 1.5 8 4c-1.6 1.7-4.6 2.6-8 2.6s-6.4-.9-8-2.6Z"/>',
  parent:
    '<circle cx="8.4" cy="5.4" r="2.6"/><path d="M4 21v-5.2a4.4 4.4 0 0 1 8.8 0V21"/>' +
    '<circle cx="17.2" cy="10.2" r="2"/><path d="M14.2 21v-3.6a3 3 0 0 1 6 0V21"/>',
  runner:
    '<circle cx="15.2" cy="4.6" r="2"/><path d="m13.6 8.4-3.5 1.9-.7 3.9 2.8 2.2.7 4.6"/>' +
    '<path d="m13.6 8.4 3.4 1.8 2.4 3"/><path d="M9.4 14.2 5 15.8"/><path d="m12.2 16.4-4 2.8"/>',
  briefcase:
    '<rect x="3" y="7" width="18" height="13" rx="2"/>' +
    '<path d="M9 7V5.6A1.6 1.6 0 0 1 10.6 4h2.8A1.6 1.6 0 0 1 15 5.6V7"/><path d="M3 12.4h18"/>',
  cap: '<path d="M12 4 2 9l10 5 10-5-10-5Z"/><path d="M6 11.4V17c0 1.7 2.7 3 6 3s6-1.3 6-3v-5.6"/>',
  heart: '<path fill="currentColor" stroke="none" d="M12 21s-8-4.8-8-10.2A4.8 4.8 0 0 1 12 7a4.8 4.8 0 0 1 8 3.8C20 16.2 12 21 12 21Z"/>'
};

function lgpSvg(name) {
  return (
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    (LGP_ICON[name] || LGP_ICON.leaf) +
    '</svg>'
  );
}

/* ── Options ──────────────────────────────────────────────── */

// Collection IDs resolved from the storefront (livgood.com/collections/<handle>.json)
const LGP_LIFESTYLES = [
  { id: '440310661433', handle: 'vegan',          title: 'Vegan',          icon: 'leaf' },
  { id: '440309907769', handle: 'gluten-free',    title: 'Gluten-Free',    icon: 'wheat' },
  { id: '440307351865', handle: 'lactose-free',   title: 'Lactose-Free',   icon: 'milk' },
  { id: '440308433209', handle: 'high-protein',   title: 'High Protein',   icon: 'dumbbell' },
  { id: '440307155257', handle: 'keto',           title: 'Keto',           icon: 'avocado' },
  { id: '440312430905', handle: 'low-calorie',    title: 'Low Calorie',    icon: 'apple' },
  { id: '440307941689', handle: 'sugar-free',     title: 'Sugar-Free',     icon: 'sugar' },
  { id: '440307581241', handle: 'organic',        title: 'Organic',        icon: 'sprout' },
  { id: '440312070457', handle: 'wheat-free',     title: 'Wheat-Free',     icon: 'wheat' },
  { id: '440311415097', handle: 'soy-free',       title: 'Soy-Free',       icon: 'pea' },
  { id: '440311775545', handle: 'tummy-friendly', title: 'Tummy Friendly', icon: 'tummy' },
  { id: '440313315641', handle: 'non-gmo',        title: 'No GMO',         icon: 'flask' }
];

const LGP_PERSONAS = [
  { id: 'dietitian',         title: 'Dietitian',                icon: 'dietitian' },
  { id: 'personal_trainer',  title: 'Personal Trainer',         icon: 'dumbbell' },
  { id: 'wellness_coach',    title: 'Wellness Coach',           icon: 'lotus' },
  { id: 'parent',            title: 'Parent',                   icon: 'parent' },
  { id: 'athlete',           title: 'Athlete',                  icon: 'runner' },
  { id: 'busy_professional', title: 'Busy Professional',        icon: 'briefcase' },
  { id: 'student',           title: 'Student',                  icon: 'cap' },
  { id: 'eating_healthier',  title: 'Just trying to eat healthier', icon: 'heart' }
];

/* ── Component ────────────────────────────────────────────── */

class LifestylePreferences {
  constructor() {
    if (window.lifestylePreferencesInstance) return window.lifestylePreferencesInstance;

    this.modal = document.getElementById('lifestyle-preferences-modal');
    if (!this.modal) return;

    this.floatingButton = document.getElementById('lifestyle-preferences-floating-button');
    this.closeButton = this.modal.querySelector('.lifestyle-preferences-close');
    this.saveButton = document.getElementById('lifestyle-preferences-save');
    this.lifestylesGrid = this.modal.querySelector('[data-lgp-lifestyles]');
    this.personasGrid = this.modal.querySelector('[data-lgp-personas]');

    this.customerEmail = (window.lifestylePreferences && window.lifestylePreferences.customerEmail) || '';
    this.isLoggedIn = !!(window.lifestylePreferences && window.lifestylePreferences.isLoggedIn);

    this.selectedLifestyles = [];
    this.selectedPersonas = [];
    // Saved collection IDs that no longer map to a chip — kept so a save never drops them.
    this.unknownCollectionIds = [];

    document.querySelectorAll('.lifestyle-preferences-overlay').forEach((el) => el.remove());
    this.overlay = document.createElement('div');
    this.overlay.className = 'lifestyle-preferences-overlay';
    document.body.appendChild(this.overlay);

    window.lifestylePreferencesInstance = this;
    this.init();
  }

  init() {
    if (!this.isLoggedIn) return;
    this.bindEvents();
    this.renderLifestyles();
    this.renderPersonas();
    this.loadSavedPreferences();
  }

  bindEvents() {
    if (this.floatingButton) {
      this.floatingButton.addEventListener('click', () => this.openModal());
    }

    // Any element in the theme can open the popup: data-lifestyle-preferences-open
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-lifestyle-preferences-open]');
      if (trigger) {
        e.preventDefault();
        this.openModal();
      }
    });

    this.closeButton.addEventListener('click', () => this.closeModal(true));
    this.overlay.addEventListener('click', () => this.closeModal(true));
    this.saveButton.addEventListener('click', () => this.savePreferences());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) this.closeModal(true);
    });
  }

  /* ── Rendering ──────────────────────────────────────────── */

  buildChip(option, selected) {
    const chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'lgp-chip' + (selected ? ' is-selected' : '');
    chip.dataset.id = option.id;
    chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
    chip.innerHTML =
      '<span class="lgp-chip__icon">' + lgpSvg(option.icon) + '</span>' +
      '<span class="lgp-chip__label">' + option.title + '</span>' +
      '<span class="lgp-chip__check" aria-hidden="true">✓</span>';
    return chip;
  }

  renderLifestyles() {
    this.lifestylesGrid.innerHTML = '';
    // Keep the class the old markup used so nothing else in the theme breaks.
    LGP_LIFESTYLES.forEach((option) => {
      const chip = this.buildChip(option, this.selectedLifestyles.includes(option.id));
      chip.classList.add('lifestyle-preferences-item');
      chip.addEventListener('click', () => this.toggle(chip, this.selectedLifestyles, option.id));
      this.lifestylesGrid.appendChild(chip);
    });
  }

  renderPersonas() {
    this.personasGrid.innerHTML = '';
    LGP_PERSONAS.forEach((option) => {
      const chip = this.buildChip(option, this.selectedPersonas.includes(option.id));
      chip.addEventListener('click', () => this.toggle(chip, this.selectedPersonas, option.id));
      this.personasGrid.appendChild(chip);
    });
  }

  toggle(chip, list, id) {
    const index = list.indexOf(id);
    if (index === -1) list.push(id);
    else list.splice(index, 1);

    const selected = index === -1;
    chip.classList.toggle('is-selected', selected);
    chip.classList.toggle('selected', selected); // legacy hook
    chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
  }

  updateUI() {
    const sync = (grid, list) => {
      grid.querySelectorAll('.lgp-chip').forEach((chip) => {
        const selected = list.includes(chip.dataset.id);
        chip.classList.toggle('is-selected', selected);
        chip.classList.toggle('selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    };
    sync(this.lifestylesGrid, this.selectedLifestyles);
    sync(this.personasGrid, this.selectedPersonas);
  }

  /* ── Open / close ───────────────────────────────────────── */

  openModal() {
    this.modal.style.display = 'flex';
    this.overlay.style.display = 'block';
    // next frame so the enter transition runs
    requestAnimationFrame(() => {
      this.modal.classList.add('active');
      this.overlay.classList.add('active');
    });
    this.modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeModal(snooze) {
    this.overlay.classList.remove('active');
    this.modal.classList.remove('active');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    if (snooze) this.snoozePrompt();

    setTimeout(() => {
      this.modal.style.display = '';
      this.overlay.style.display = '';
    }, 300);
  }

  snoozePrompt() {
    try {
      const until = Date.now() + LGP_SNOOZE_DAYS * 24 * 60 * 60 * 1000;
      localStorage.setItem(LGP_STORAGE_SNOOZE, String(until));
    } catch (e) { /* storage unavailable */ }
  }

  isSnoozed() {
    try {
      const until = parseInt(localStorage.getItem(LGP_STORAGE_SNOOZE) || '0', 10);
      return Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  /* ── Data ───────────────────────────────────────────────── */

  async loadSavedPreferences() {
    if (!this.customerEmail) return;

    // Local storage first so the popup paints selections immediately.
    try {
      const cachedCollections = localStorage.getItem(LGP_STORAGE_COLLECTIONS);
      if (cachedCollections) this.selectedLifestyles = JSON.parse(cachedCollections) || [];
      const cachedPersonas = localStorage.getItem(LGP_STORAGE_PERSONAS);
      if (cachedPersonas) this.selectedPersonas = JSON.parse(cachedPersonas) || [];
    } catch (e) { /* ignore malformed cache */ }

    let fetched = false;

    try {
      const response = await fetch(LGP_API_BASE + '/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ email: this.customerEmail })
      });

      if (response.ok) {
        const data = await response.json();
        if (data.status === 'success') {
          fetched = true;

          const ids = (Array.isArray(data.data) ? data.data : [])
            .map((gid) => {
              const match = String(gid).match(/Collection\/(\d+)/);
              return match ? match[1] : null;
            })
            .filter(Boolean);

          const known = LGP_LIFESTYLES.map((l) => l.id);
          this.selectedLifestyles = ids.filter((id) => known.includes(id));
          this.unknownCollectionIds = ids.filter((id) => !known.includes(id));

          this.selectedPersonas = Array.isArray(data.personas) ? data.personas.map(String) : [];

          this.cacheLocally();
        }
      }
    } catch (error) {
      console.error('[lifestyle-preferences] failed to load preferences', error);
    }

    this.updateUI();

    // First-time customers: open the popup for them.
    const hasPreferences = this.selectedLifestyles.length > 0 || this.selectedPersonas.length > 0 ||
      this.unknownCollectionIds.length > 0;
    if (fetched && !hasPreferences && !this.isSnoozed()) {
      setTimeout(() => this.openModal(), 1200);
    }
  }

  cacheLocally() {
    try {
      // The lifestyle products carousel reads this key — keep it as plain numeric IDs.
      localStorage.setItem(
        LGP_STORAGE_COLLECTIONS,
        JSON.stringify(this.selectedLifestyles.concat(this.unknownCollectionIds))
      );
      localStorage.setItem(LGP_STORAGE_PERSONAS, JSON.stringify(this.selectedPersonas));
    } catch (e) { /* storage unavailable */ }
  }

  async savePreferences() {
    if (!this.customerEmail) return;

    const label = this.saveButton.querySelector('span');
    const originalLabel = label ? label.textContent : '';
    this.saveButton.disabled = true;
    if (label) label.textContent = 'Saving…';

    const collectionIds = this.selectedLifestyles
      .concat(this.unknownCollectionIds)
      .map((id) => 'gid://shopify/Collection/' + id);

    try {
      const response = await fetch(LGP_API_BASE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: this.customerEmail,
          collectionIds: collectionIds,
          personas: this.selectedPersonas
        })
      });

      const data = await response.json();
      if (data.status !== 'success') throw new Error('API returned ' + data.status);

      this.cacheLocally();
      this.closeModal(false);
      this.showToast('Your preferences have been saved!');
    } catch (error) {
      console.error('[lifestyle-preferences] failed to save preferences', error);
      this.showToast('Failed to save preferences. Please try again.');
    } finally {
      this.saveButton.disabled = false;
      if (label) label.textContent = originalLabel;
    }
  }

  showToast(message) {
    let toast = document.querySelector('.lifestyle-preferences-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'lifestyle-preferences-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('active');
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => toast.classList.remove('active'), 3000);
  }
}

/* ── Boot ─────────────────────────────────────────────────── */

function initLifestylePreferences() {
  if (window.lifestylePreferencesInstance) return;
  if (document.getElementById('lifestyle-preferences-modal')) new LifestylePreferences();
}

initLifestylePreferences();
document.addEventListener('DOMContentLoaded', initLifestylePreferences);
setTimeout(initLifestylePreferences, 1500);
